import React, { useState, Fragment, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  makeStyles,
  Grid,
  Backdrop,
  CircularProgress,
  TextField,
  Divider,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Autocomplete from "@material-ui/lab/Autocomplete";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import Alert from "widgets/alert";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import { clientPay } from "configurations/axios";
import {
  API_GET_ALL_COMPANY,
  API_GET_AVAILABLE_VOUCHERS,
  API_GET_SEARCH_COMPANY,
  API_POST_SAVE_ADD_VOUCHER,
} from "../apis";
const useStyles = makeStyles((theme) => ({
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  textFieldComboBox: {
    minWidth: "100%",
    maxWidth: "100%",
  },
  form: {
    borderWidth: "1px",
    border: "1px solid  #aaaaaa",
    borderRadius: "8px",
    width: "100%",
    padding: "1%",
  },
  button: {
    marginTop: "0.5%",
    width: "80%",
    maxWidth: "80%",
    padding: "0.5%",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: palette.primary.dark,
    borderRadius: "8px",
    "&:hover": {
      color: palette.primary.contrastText,
      background: palette.primary.main,
    },
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  form: {
    borderWidth: "1px",
    border: "1px solid  #aaaaaa",
    borderRadius: "8px",
    width: "100%",
    padding: "1%",
  },
  button: {
    marginTop: "0.5%",
    width: "80%",
    maxWidth: "80%",
    padding: "0.5%",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: palette.primary.dark,
    borderRadius: "8px",
    "&:hover": {
      color: palette.primary.contrastText,
      background: palette.primary.main,
    },
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const AsignarComprobantes = ({ updateView }) => {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [openLoader, setOpenLoader] = useState(false);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [open, setOpen] = useState(false);
  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const userToken = useSelector((state) => state.user.tk);
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErros] = useState({});
  const [packet, setPacket] = useState({});
  const [availableVouchers, setAvailableVouchers] = useState("");
  const [foundClient, setFoundClient] = useState({});
  const [openSearch, setOpenSearch] = useState(false);
  const loading = openSearch && company.length === 0;

  const handleClickOpen = () => {
    setOpen(true);
    setErros({});
    setSelectedCompany({});
  };

  useEffect(() => {
    if (!openSearch) {
      setCompany([]);
    }
  }, [openSearch]);

  const handleClose = () => {
    setOpen(false);
    setMsg({ show: false, msg: null, type: null });
    setCompany([]);
  };
  function closeAlert() {
    setMsg({ show: false });
  }

  const getAvailableVouchers = async (token) => {
    await clientPay
      .get(API_GET_AVAILABLE_VOUCHERS + (token ? getRUCEmpresa(token) : "0"))
      .then((result) => {
        if (result.status === 200) {
          if (result.data == -1) {
            setAvailableVouchers("Ilimitado");
          } else {
            setAvailableVouchers(result.data);
          }
        }
      })
      .catch((exception) => {
        setAvailableVouchers([
          { label: "Error al obtener comprobantes disponibles" },
        ]);
        setMsg({
          show: true,
          msg: "Ocurrió un problema al obtener comprobantes disponibles.",
        });
      });
  };

  const getCompanies = async (token) => {
    if (open) {
      await clientPay
        .get(
          API_GET_ALL_COMPANY +
            (token ? getRUCEmpresa(token) : "0") +
            "?page=0&size=100"
        )
        .then((result) => {
          if (result.status === 200) {
            let companies = result.data.content;
            for (let i = 0; i < companies.length; i++) {
              companies[i].label =
                companies[i].razonSocialempresa +
                " / " +
                companies[i].idempresacontratante;
            }
            setCompany(companies);
          }
        })
        .catch((exception) => {
          setCompany([{ label: "Error al cargar las empresas" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las empresas.",
          });
        });
    }
  };

  const renderAvailableVouchers = () => {
    if (availableVouchers === "" && userToken) {
      getAvailableVouchers(userToken);
    }
    return (
      <Grid item xs={12} md={8}>
        <input
          class={
            availableVouchers <= 0
              ? " form-control is-invalid"
              : "form-control is-valid"
          }
          disabled
          defaultValue={availableVouchers}
        ></input>
        {errors.availableVouchers ? (
          <p className={classesApp.errorLetters}>{errors.availableVouchers}</p>
        ) : null}
      </Grid>
    );
  };

  const renderCompanies = () => {
    if (company.length === 0 && userToken) {
      getCompanies(userToken);
    }
    return (
      <Autocomplete
        value={selectedCompany}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
          setPacket({
            ...packet,
            rucEmpresa: newValue.idempresacontratante,
            rucPartner: newValue.rucEmpresaContadora,
          });
        }}
        options={company}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={company.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de empresas"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {company.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  //método para la busqueda
  const searchClients = async (params) => {
    await clientPay
      .get(
        API_GET_SEARCH_COMPANY +
          getRUCEmpresa(userToken) +
          "?parametroBusqueda=" +
          params
      )
      .then((response) => {
        if (response.status === 200) {
          //setOptions(Object.keys(response.data).map((cliente) => response.data[cliente].cliente));
          if (Array.isArray(response.data)) {
            if (response.data.length > 0) {
              let companies = response.data;
              for (let i = 0; i < companies.length; i++) {
                companies[i].label =
                  companies[i].razonSocialempresa +
                  " / " +
                  companies[i].idempresacontratante;
              }
              setCompany(companies);
            } else {
              setCompany([
                {
                  label: "No se encontró datos con el argumento ingresado",
                },
              ]);
            }
          }
          setOpenSearch(true);
        }
      })
      .catch((exception) => {
        if (exception.response) {
          setCompany([
            {
              label: "No se encontró datos con el argumento ingresado",
            },
          ]);
        } else {
          setCompany([
            {
              label: "Error en la red al consultar el cliente.",
            },
          ]);
        }
      });
  };

  const handleChange = (event) => {
    setPacket({
      ...packet,
      [event.target.name]: event.target.value,
    });
  };

  const handleAddVouchers = async (event) => {
    let validations = {};
    setOpenLoader(true);
    event.preventDefault();
    if (selectedCompany) {
      if (
        selectedCompany.idempresacontratante === null ||
        typeof selectedCompany.idempresacontratante === "undefined"
      ) {
        validations.selectedCompany = "Seleccione una empresa.";
      }
    } else {
      validations.selectedCompany = "Seleccione una empresa.";
    }
    if (
      packet.numeroComprobantes === null ||
      typeof packet.numeroComprobantes === "undefined"
    ) {
      validations.numeroComprobantes = "Ingrese un número de comprobantes.";
    }
    if (Object.keys(validations).length === 0) {
      await clientPay
        .post(API_POST_SAVE_ADD_VOUCHER, packet)
        .then((response) => {
          enqueueSnackbar("Comprobantes asignados.", {
            variant: "success",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            autoHideDuration: 10000,
          });
          updateView();
          handleClose();
          setOpenLoader(false);
        })
        .catch((exception) => {
          if (exception.response) {
            if (exception.response.status === 400) {
              setMsg({
                show: true,
                msg: "No se pudo asignar los comprobantes a la empresa.",
              });
            } else if (exception.response.status === 404) {
              setMsg({
                show: true,
                msg: "No se encontró la empresa para asignar.",
              });
            } else {
              setMsg({
                show: true,
                msg: "Error al asignar comprobantes a la empresa. Contáctese con el administrador del Sistema.",
              });
            }
          } else {
            setMsg({
              show: true,
              msg: "Existen problemas en la red. Contáctese con el administrador del Sistema.",
            });
          }
          setOpenLoader(false);
        });
    } else {
      setErros(validations);
      setOpenLoader(false);
    }
  };

  return (
    <Fragment>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        <AddCircleIcon
          style={{ color: palette.primary.contrastText, paddingRight: "3%" }}
          fontSize="small"
        />
        Asignar comprobantes
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={open}
        onClose={handleClose}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle id="max-width-dialog-title">
          Asignar comprobantes a empresas afiliadas al partner{" "}
        </DialogTitle>
        <DialogContent>
          <form onSubmit={handleAddVouchers}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-start"
              alignItems="center"
            >
              <Grid item xs={12} md={12}>
                <label>
                  Los campos marcados con ({" "}
                  <font color={palette.error.main}> *</font> ) son obligatorios:
                </label>
              </Grid>
              {msgError.show ? (
                <Alert
                  tipo={msgError.type}
                  mensaje={msgError.msg}
                  mesajeSubrayado={null}
                  titulo={null}
                  mostrar={msgError.show}
                  cerrarAlerta={closeAlert}
                />
              ) : null}
              <Grid item xs={12} md={4}>
                Cantidad de Comprobantes disponibles:
              </Grid>
              {renderAvailableVouchers()}
              <Grid item xs={12} md={4}>
                Empresa: <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <Autocomplete
                  id="rucCliente"
                  onChange={(e, value) => {
                    setFoundClient(value);
                    if (value !== null) {
                      setSelectedCompany(value);
                      setPacket({
                        ...packet,
                        rucEmpresa: value.idempresacontratante,
                        rucPartner: value.rucEmpresaContadora,
                      });
                    } else {
                      setSelectedCompany({});
                    }
                  }}
                  open={openSearch}
                  onOpen={() => {
                    setOpenSearch(true);
                  }}
                  onClose={() => {
                    setOpenSearch(false);
                  }}
                  getOptionDisabled={(option) =>
                    option.label.includes(
                      "No se encontró datos con el argumento ingresado"
                    ) ||
                    option.label.includes(
                      "Error en la red al consultar el cliente."
                    )
                  }
                  getOptionSelected={(option, value) =>
                    option.idempresacontratante === value.idempresacontratante
                  }
                  getOptionLabel={(option) => option.label}
                  options={company}
                  noOptionsText={
                    "No se encontró datos con el argumento ingresado"
                  }
                  //inputValue={foundClient}
                  loadingText="Ingrese al menos 3 caracteres"
                  loading={company.length === 0}
                  renderInput={(params) => (
                    <TextField
                      className={
                        foundClient
                          ? foundClient.label
                            ? "form-control  is-valid"
                            : null
                          : null
                      }
                      onChange={(event) => {
                        if (event.target.value.length > 2) {
                          searchClients(event.target.value);
                        }
                      }}
                      {...params}
                      variant="outlined"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
                <small style={{ color: "#818181" }}>
                  Puede buscarlo por el RUC o Razón Social.
                </small>
                {errors.selectedCompany ? (
                  <p className={classesApp.errorLetters}>
                    {errors.selectedCompany}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Número de comprobantes a agregar:{" "}
                <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="number"
                  value={packet.numeroComprobantes}
                  onChange={handleChange}
                  name="numeroComprobantes"
                  className={
                    errors.numeroComprobantes
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                ></input>
                {errors.numeroComprobantes ? (
                  <p className={classesApp.errorLetters}>
                    {errors.numeroComprobantes}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Precio de comprobantes:{" "}
                <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="number"
                  value={packet.precioComprobantes}
                  onChange={handleChange}
                  name="precioComprobantes"
                  className={
                    errors.precioComprobantes
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                ></input>
                {errors.precioComprobantes ? (
                  <p className={classesApp.errorLetters}>
                    {errors.precioComprobantes}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Fecha fin de contratación:{" "}
                <font color={palette.error.main}> *</font>
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="date"
                  value={packet.fechaFinContratacion}
                  onChange={handleChange}
                  name="fechaFinContratacion"
                  className={
                    errors.fechaFinContratacion
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                ></input>
                {errors.fechaFinContratacion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.fechaFinContratacion}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={4}>
                Observación:
              </Grid>
              <Grid item xs={12} md={8}>
                <input
                  type="text"
                  value={packet.observacion}
                  onChange={handleChange}
                  name="observacion"
                  className={
                    errors.observacion
                      ? "form-control is-invalid"
                      : "form-control"
                  }
                ></input>
                {errors.observacion ? (
                  <p className={classesApp.errorLetters}>
                    {errors.observacion}
                  </p>
                ) : null}
              </Grid>
              <Grid container spacing={3} justify="center">
                <Grid item md={12} xs={12}>
                  <Divider></Divider>
                </Grid>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classesGlobal.marginButton}
                >
                  Agregar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  className={classesGlobal.marginButton}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Backdrop className={classes.backdrop} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
};

export default AsignarComprobantes;
